import { render, staticRenderFns } from "./PrismDisplay.vue?vue&type=template&id=2400b8d0"
import script from "./PrismDisplay.vue?vue&type=script&lang=js"
export * from "./PrismDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports